module.exports = __webpack_public_path__ + "img/cons_8.c7c3f976.jpg";